// extracted by mini-css-extract-plugin
export default {"Box":"column-frame-module__Box--WK7co","Box_1":"column-frame-module__Box_1--xn81K"};